/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetMarketMakerOptions,
  GetMarketMakerStatus200,
  GetMarketMakerStatus400,
  GetMarketMakerStatus401,
  GetMarketMakerStatus403,
  GetMarketMakerStatus404,
  GetMarketMakerStatus409,
  GetMarketMakerStatus500,
} from '../types/GetMarketMaker'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getMarketMaker } from '../clients/getMarketMaker'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getMarketMakerQueryKey = ({ path }: Omit<GetMarketMakerOptions, 'headers'>) =>
  [{ url: '/v1/market-makers/:market_maker_id', params: path }] as const

type GetMarketMakerQueryKey = ReturnType<typeof getMarketMakerQueryKey>

export function getMarketMakerQueryOptions(
  { path }: GetMarketMakerOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getMarketMakerQueryKey({ path })
  return queryOptions<
    GetMarketMakerStatus200,
    ResponseErrorConfig<
      | GetMarketMakerStatus400
      | GetMarketMakerStatus401
      | GetMarketMakerStatus403
      | GetMarketMakerStatus404
      | GetMarketMakerStatus409
      | GetMarketMakerStatus500
    >,
    GetMarketMakerStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getMarketMaker({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Admin only. All percentages are fractions in [0,1].
 * @summary Get a market maker
 * {@link /v1/market-makers/:market_maker_id}
 */
export function useGetMarketMaker<
  TData = GetMarketMakerStatus200,
  TQueryData = GetMarketMakerStatus200,
  TQueryKey extends QueryKey = GetMarketMakerQueryKey,
>(
  { path }: { path: GetMarketMakerOptions['path'] | (() => GetMarketMakerOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetMarketMakerStatus200,
        ResponseErrorConfig<
          | GetMarketMakerStatus400
          | GetMarketMakerStatus401
          | GetMarketMakerStatus403
          | GetMarketMakerStatus404
          | GetMarketMakerStatus409
          | GetMarketMakerStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getMarketMakerQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getMarketMakerQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetMarketMakerStatus400
      | GetMarketMakerStatus401
      | GetMarketMakerStatus403
      | GetMarketMakerStatus404
      | GetMarketMakerStatus409
      | GetMarketMakerStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
